import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'home',
  setup(__props) {

const list = [
  { label: '世界各国网址大全', url: 'http://www.world68.com/' },
  { label: 'pmgeek', url: 'https://pmgeek.net/cn/index.html' },
  { label: '站长工具', url: 'https://tool.chinaz.com/' },
  { label: '别看了学不会', url: 'http://www.4243.net/' },
  {
    label: '别看了学不会',
    url: 'https://github.com/azl397985856/leetcode'
  },
  {
    label: '别看了学不会',
    url: 'https://github.com/scutan90/DeepLearning-500-questions'
  },
  {
    label: 'iloveimg 压缩图片 修改图片',
    url: 'https://www.iloveimg.com/zh-cn'
  },
  { label: 'hipdf', url: 'https://www.hipdf.cn/' },
  { label: 'alltoall', url: 'https://www.alltoall.net/' }
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", null, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(list, (item) => {
      return _createElementVNode("li", {
        key: item.url
      }, _toDisplayString(item.label), 1)
    }), 64))
  ]))
}
}

})